import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { ReviewDataCardComponent } from "../review-card/review-data-card.component";
import { ReviewService } from "../review.service";
import { HttpCommonService, LookupService, AuthService } from "projects/sepidz-web-framework/src/lib/services";
import { ReviewFilter } from "../models/review-filter";
import { ReviewFilterItem } from "../models/review-filter-item";
import { CheckboxLlist } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/checkbox-list/checkbox-list.model";
import { takeUntil, finalize, pairwise } from "rxjs/operators";
import { Subject } from "rxjs";

@Component({
  selector: "sepidz-remote-select-review",
  templateUrl: "./remote-select-review.component.html",
  styleUrls: ["./remote-select-review.component.scss"],
})
export class RemoteSelectReviewComponent extends ReviewDataCardComponent implements OnInit {
  ngUnsubscribe = new Subject<void>();
  @Input() items: CheckboxLlist[] = [];
  dataList: any[];
  @Input() form: UntypedFormGroup;
  @Input() textFieldName: string = "Title";
  @Output() onChange = new EventEmitter();
  constructor(service: ReviewService, fetchService: HttpCommonService, protected lookupservice: LookupService, protected authService: AuthService) {
    super(service, fetchService, lookupservice, authService);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.service.filter$.pipe(pairwise(), takeUntil(this.ngUnsubscribe)).subscribe(([prev, next]) => {
      if (next && next.changedKeys?.length > 0 && JSON.stringify(prev?.items) === JSON.stringify(next?.items)) {
        const relatedFilter = prev?.items.find((x) => x.key === this.key);
        if (relatedFilter && this.form?.controls[this.key]) {
          this.form.controls[this.key]?.setValue([relatedFilter.value]);
        }
      }
    });
  }
  setDefaultFilterValue() {
    const filtersValue = this.service.filterSubject.getValue();
    if (filtersValue && filtersValue.items?.length) {
      const relatedFilter = filtersValue.items.filter((x) => x.key === this.key);
      if (relatedFilter && this.form?.controls[this.key]) {
        const value = relatedFilter?.map((x) => x.value);
        this.form.controls[this.key]?.setValue(value);
      }
    }
  }

  protected prepareFilterForLoading(filter: ReviewFilter) {
    const filterForLoad = { ...filter };
    filterForLoad.items = filter.items;
    return filterForLoad;
  }

  protected filterChanging(filter: ReviewFilter): void {
    this.items.forEach((item) => {
      item.Selected = filter.items.some((filterItem) => filterItem.key === this.key && filterItem.value === item.Id);
    });
  }

  protected loadItems(filter: ReviewFilter): void {
    try {
      if (!this.loaded) {
        this.loadingSubject.next(true);
        if (!this.category && this.apiName) {
          this.fetchService
            .getList(this.apiName)
            .pipe(finalize(() => this.loadingSubject.next(false)))
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
              (result: any[]) => {
                if (result && result.length > 0) {
                  this.dataList = result as [];
                  this.setDefaultFilterValue();
                  this.retrieved(result);
                }
              },
              (error) => console.log("fetch error: " + error)
            );
        } else {
          this.lookupservice
            .getLookupbyCategory(this.systemName, this.category)
            .pipe(finalize(() => this.loadingSubject.next(false)))
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
              (result) => {
                if ((result as []) && (result as []).length > 0) {
                  this.dataList = result as [];
                  this.setDefaultFilterValue();
                  this.retrieved(result);
                }
              },
              (error) => console.log("fetch error: " + error)
            );
        }
      }
    } catch (e) {
      console.log(e);
    }
  }

  changed(value: any) {
    this.onChange.emit(value);
    if (value.Selected) {
      this.service.addFilter(this.name, [
        <ReviewFilterItem>{
          key: this.key,
          value: value.Id,
          title: value.Title,
          persianKey: this.title,
        },
      ]);
    } else {
      this.service.removeFilter(this.name, this.key, [value.Id], "array",true);
    }
  }

  protected retrieved(data: any): void {
    this.items = [];
    if (data && data.length) {
      const ids: any[] = this.form.controls[this.key]?.value;
      data.forEach((x) => {
        if (ids.includes(x.Id)) {
          x.Selected = true;
        }
      });
      this.items = <Array<any>>data.map((c: any) => <CheckboxLlist>{ Title: c[this.textFieldName], Id: c.Id, Selected: c.Selected });
    }
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    if (this.ngUnsubscribe) {
      this.ngUnsubscribe.next();
      this.ngUnsubscribe.complete();
    }
    this.items = undefined;
    this.dataList = undefined;
    this.form = undefined;
  }
}
